import React from "react"
import styled from "styled-components"
import { Icon } from "antd"

import { getColor, colors } from "../../../../components/Color"
import Text from "../../../../components/New/Text/Text"
import Title from "../../../../components/New/Text/Title"
import Link from "../../../../Sections/New/NewLink"

const Option = styled.div`
  background: ${({ color }) =>
    color === "grey" ? `${getColor("grey", 0.5)}` : `${colors.beige}`};
  width: ${({ carousel }) => (carousel ? "100%" : "360px" )};
  border: ${({ selected }) =>
    selected ? "black 1px solid" : "black 1px solid%"};
  min-height: 383px;
  display: flex;
  flex-direction: column;
  padding: 22px;
  margin: 12px auto;
`

const Divider = styled.div`
  border-top: 1px solid black;
  opacity: 0.5;
  margin-top: 12px;
  margin-bottom: 12px;
`

const Detail = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
`

const Details = styled.div`
  display: flex;
  flex-direction: column;
  margin: 24px 0px;
  align-items: space-between;
`

const DetailList = ({ details }) => {
  return (
    <Details>
      {details.map(detail => {
        return (
          <Detail key={detail}>
            <Icon type="check-circle" style={{ margin: "6px" }} />
            <Text size="medium">{detail}</Text>
          </Detail>
        )
      })}
    </Details>
  )
}

const ResultOptionPanel = ({
  panel,
  color,
  carousel,
  clickAction,
  selected,
}) => {
  const {
    headline,
    subheadline,
    details,
    additionalInfo,
    price,
    internalLink,
    state,
  } = panel
  return (
    <Option
      color={color}
      carousel={carousel}
      onClick={clickAction}
      selected={selected}
    >
      <Text style={{ fontWeight: "700" }} size="large">
        {headline}
      </Text>
      <Text size="medium">{subheadline}</Text>
      <DetailList details={details} />
      <Divider />
      <Text size="medium">{additionalInfo}</Text>
      <Divider />
      <Title size="large">{price}</Title>
    </Option>
  )
}

export default ResultOptionPanel
